import React from 'react';
import { render } from 'react-dom';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};

// render app with server props to the DOM
render(<App {...props} />, document.getElementById('root'));

// set up initial GA tracking
const { launchNewNavigationHeader } = props.env;
const dimensionValue = launchNewNavigationHeader
    ? '20q4navexperiment-new'
    : '20q4navexperiment-old';
const dimensions = {
    experimentId3: dimensionValue,
};

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings, { dimensions });
